import { all, call, put, takeLatest } from 'typed-redux-saga/macro';

import { AUTH_ACTION_TYPES } from './auth.types';


import { getUserProfileAfterSignIn, signInWithEmailAndPassword } from '../../utils/api/auth.utils';
import { setIsError } from '../error/error.action';
import { setIsLoading } from '../loading/loading.action';
import {
    SignInStart,
    SignInSuccess,
    getUserProfileFailed,
    getUserProfileStart,
    getUserProfileSuccess,
    signInFailed,
    signInSuccess
} from './auth.action';

export function* signIn({
    payload: { email, password, onComplete },
}: SignInStart) {
    yield* put(setIsLoading(true));
    try {
        const accessToken = yield* call(
            signInWithEmailAndPassword,
            email,
            password);

        if (accessToken) {
            yield* put(signInSuccess(accessToken));
        }
        yield* put(setIsLoading(false));
        onComplete();
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(signInFailed(errorResponse));
        yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* getUserProfile({
    payload: { accessToken },
}: SignInSuccess) {
    yield* put(setIsLoading(true));
    try {

        yield* put(getUserProfileStart(accessToken));

        const userProfile = yield* call(
            getUserProfileAfterSignIn, accessToken
        );

        if (userProfile) {
            yield* put(getUserProfileSuccess(accessToken, userProfile));
        }
        yield* put(setIsLoading(false));
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getUserProfileFailed(errorResponse));
        yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* onSignInStart() {
    yield* takeLatest(AUTH_ACTION_TYPES.SIGN_IN_START, signIn);
}

export function* onSignInSuccess() {
    yield* takeLatest(AUTH_ACTION_TYPES.SIGN_IN_SUCCESS, getUserProfile);
}

export function* authSaga() {
    yield* all([
        call(onSignInStart),
        call(onSignInSuccess),
    ]);
}
